import { render, staticRenderFns } from "./supStat.vue?vue&type=template&id=1be9fc2c&scoped=true&"
import script from "./supStat.vue?vue&type=script&lang=js&"
export * from "./supStat.vue?vue&type=script&lang=js&"
import style0 from "./supStat.vue?vue&type=style&index=0&id=1be9fc2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be9fc2c",
  null
  
)

component.options.__file = "supStat.vue"
export default component.exports